var map = {
	"./about.json": "6633",
	"./areas.json": "25d5",
	"./areas_district_available_days.json": "7163",
	"./banners.json": "664b",
	"./branches.json": "d9bf",
	"./cancel_reasons.json": "f30a",
	"./companies.json": "3b00",
	"./contacts.json": "0a7a",
	"./customers.json": "8f69",
	"./delivery_app_version.json": "86c7",
	"./delivery_men.json": "b9ee",
	"./dm_weight_targets.json": "f490",
	"./filter.json": "978c",
	"./integrations.json": "f9c1",
	"./inventories.json": "11f3",
	"./inventory_logs.json": "7bed",
	"./menu.json": "350a",
	"./notifications_sub.json": "a9fd",
	"./order_notes.json": "dbf7",
	"./order_status.json": "e23f",
	"./orders.json": "486c",
	"./popups.json": "34ab",
	"./ref_roles.json": "0dc3",
	"./status.json": "3f1f",
	"./tickets.json": "b1fb",
	"./tickets_replayes.json": "3acd",
	"./tickets_status.json": "e133",
	"./user_roles.json": "073f",
	"./user_roles_permissions.json": "1ab3",
	"./users.json": "8dfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7cc";